import axios from 'axios'

export default class Perfil {
  constructor (tokenBearer, url, id) {
    this.url = `${url}/api/unimed`
    this.tokenBearer = tokenBearer
  }

  async editarCompetencia (tipoPerfil, idUnimed, competenciaId) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.url}/${tipoPerfil}/${idUnimed}/editar/${competenciaId}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseEdicao = await axios(options)
        resolve(responseEdicao)
      } catch (err) {
        reject(err)
      }
    })
  }
}
